/**
 * Mirrors horizontal scroll between a top scrollbar track and the main table wrapper
 * so wide product row tables are usable without scrolling to the bottom of the list.
 */
(function () {
  function updateSpacer(spacer, table) {
    spacer.style.width = `${table.scrollWidth}px`;
  }

  function initProductRowsDualScroll(root) {
    if (!(root instanceof HTMLElement)) return;

    const top = root.querySelector('.product-rows-table-scroll-top');
    const bottom = root.querySelector('.product-rows-table-wrapper');
    const spacer = root.querySelector('.product-rows-table-scroll-spacer');
    const table = bottom?.querySelector('.product-rows-table');

    if (!top || !bottom || !spacer || !table) return;

    if (typeof root._dualScrollCleanup === 'function') {
      root._dualScrollCleanup();
      root._dualScrollCleanup = null;
    }

    let syncing = false;

    const onTopScroll = () => {
      if (syncing) return;
      syncing = true;
      bottom.scrollLeft = top.scrollLeft;
      requestAnimationFrame(() => {
        syncing = false;
      });
    };

    const onBottomScroll = () => {
      if (syncing) return;
      syncing = true;
      top.scrollLeft = bottom.scrollLeft;
      requestAnimationFrame(() => {
        syncing = false;
      });
    };

    top.addEventListener('scroll', onTopScroll, { passive: true });
    bottom.addEventListener('scroll', onBottomScroll, { passive: true });

    const applySpacer = () => {
      updateSpacer(spacer, table);
      top.scrollLeft = bottom.scrollLeft;
    };

    const ro = new ResizeObserver(applySpacer);
    ro.observe(table);
    ro.observe(bottom);
    applySpacer();

    root._dualScrollCleanup = () => {
      top.removeEventListener('scroll', onTopScroll);
      bottom.removeEventListener('scroll', onBottomScroll);
      ro.disconnect();
    };
  }

  function initAll(container) {
    const scope = container instanceof HTMLElement ? container : document;
    scope.querySelectorAll('.product-rows-table-dual-scroll').forEach(initProductRowsDualScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (section instanceof HTMLElement) initAll(section);
  });

  const grid = document.getElementById('ProductGridContainer');
  if (grid) {
    let scheduled = false;
    const mo = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        initAll(grid);
      });
    });
    mo.observe(grid, { childList: true, subtree: true });
  }
})();
